import { ProjectMenus } from '../contracts/project-menu';
import { UserPermissions } from './permissions';

export const OcfaMenu: ProjectMenus = [
  {title: 'clients',          path: 'ocfa/clients',     icon: 'group'},
  {title: 'report',           path: 'reports',           icon: 'assessment'},
  {title: 'organizations',    path: 'organizations',     icon: 'business',         role: [UserPermissions.OrganizationsMenu]},
  {title: 'cites',            path: 'cities',            icon: 'location_city',    role: [UserPermissions.CitiesMenu]},
  {title: 'users',            path: 'users',             icon: 'manage_accounts',  role: [UserPermissions.EditUsers]},
  {title: 'service_point',    path: 'service-points',    icon: 'room',             role: [UserPermissions.AvailableUsersServicePoints]},
];

export const OcfaUkraineMenu: ProjectMenus = [
  ...OcfaMenu,
  {title: 'lpu',              path: 'ocfa/mpi',                   icon: 'local_hospital',   role: [UserPermissions.MpiMenu]},
  {title: 'case_managers',    path: 'participant/casemanager',    icon: 'people',           role: [UserPermissions.CaseManagerMenu]},
  {title: 'medassistant',     path: 'participant/medassistant',   icon: 'medical_services', role: [UserPermissions.MedAssistantMenu]},
  {title: 'autrich_workers',  path: 'participant/outreachworker', icon: 'directions_walk',  role: [UserPermissions.OutreachWorkerMenu]},
  {title: 'roles',            path: 'roles',                      icon: 'security',         role: [UserPermissions.AvailableAllRoles]},
  {title: 'response_changes', path: 'delete-requests',            icon: 'delete_sweep',     role: [UserPermissions.DeleteRequests]},
  {title: 'updates',          path: 'renovation',                 icon: 'build'},
];

export const TgMenu: ProjectMenus = [
  {title: 'questionnaire',    path: 'surveys',           icon: 'list_alt',         role: [UserPermissions.SurveysMenu]},
  {title: 'report',           path: 'reports',           icon: 'assessment'},
  {title: 'organizations',    path: 'organizations',     icon: 'business',         role: [UserPermissions.OrganizationsMenu]},
  {title: 'cites',            path: 'cities',            icon: 'location_city',    role: [UserPermissions.CitiesMenu]},
  {title: 'users',            path: 'users',             icon: 'manage_accounts',  role: [UserPermissions.EditUsers]},
];

export const CitiMenu: ProjectMenus = [
  {title: 'clients',          path: 'citi/clients',      icon: 'group'},
  {title: 'report',           path: 'reports',           icon: 'assessment'},
  {title: 'organizations',    path: 'organizations',     icon: 'business',         role: [UserPermissions.OrganizationsMenu]},
  {title: 'cites',            path: 'cities',            icon: 'location_city',    role: [UserPermissions.CitiesMenu]},
  {title: 'users',            path: 'users',             icon: 'manage_accounts',  role: [UserPermissions.EditUsers]},
  {title: 'service_point',    path: 'service-points',    icon: 'room',             role: [UserPermissions.AvailableUsersServicePoints]},
  {title: 'lpu',              path: 'citi/mpi',          icon: 'local_hospital',   role: [UserPermissions.MpiMenu]},
  {title: 'response_changes', path: 'delete-requests',   icon: 'delete_sweep',     role: [UserPermissions.DeleteRequests]},
  {title: 'updates',          path: 'renovation',        icon: 'build'},
];

export const PdiMenu: ProjectMenus = [
  {title: 'clients',          path: 'pdi/clients',       icon: 'group'},
  {title: 'questionnaire',    path: 'surveys',           icon: 'list_alt',         role: [UserPermissions.SurveysMenu]},
  {title: 'report',           path: 'reports',           icon: 'assessment'},
  {title: 'organizations',    path: 'organizations',     icon: 'business',         role: [UserPermissions.OrganizationsMenu]},
  {title: 'cites',            path: 'cities',            icon: 'location_city',    role: [UserPermissions.CitiesMenu]},
  {title: 'users',            path: 'users',             icon: 'manage_accounts',  role: [UserPermissions.EditUsers]},
  {title: 'service_point',    path: 'service-points',    icon: 'room',             role: [UserPermissions.AvailableUsersServicePoints]},
  {title: 'lpu',              path: 'mpi',               icon: 'local_hospital',   role: [UserPermissions.MpiMenu]},
  {title: 'roles',            path: 'roles',             icon: 'security',         role: [UserPermissions.AvailableAllRoles]},
  {title: 'response_changes', path: 'delete-requests',   icon: 'delete_sweep',     role: [UserPermissions.DeleteRequests]},
  {title: 'updates',          path: 'renovation',        icon: 'build'},
];
